const PACKAGE_LABELS = {
  WAITING_FOR_PICKUP: "Waiting for Pickup",
  PICKED_UP_BY_RIDER: "Picked Up",
  DROPPED_AT_WAREHOUSE: "Dropped at Warehouse",
  RECEIVED_AT_WAREHOUSE: "At Warehouse",
  SORTING_IN_WAREHOUSE: "Sorting",
  ADDED_TO_OUTBOUND_BATCH: "In Outbound Batch",
  OUTBOUND_BATCH_READY: "Batch Ready",
  SHIPPED_OUT: "Shipped Out (Warehouse)",
  READY_FOR_LAST_MILE_PICKUP: "Ready for Last-Mile",
  OUT_FOR_LAST_MILE: "Out for Delivery",
  DELIVERED: "Delivered",
  ON_HOLD_WAREHOUSE_ISSUE: "On Hold (Issue)",
  CANCELLED: "Cancelled",
};

const PACKAGE_COLORS = {
  WAITING_FOR_PICKUP: "bg-yellow-500/10 text-yellow-400 border-yellow-500/30",
  PICKED_UP_BY_RIDER: "bg-blue-500/10 text-blue-400 border-blue-500/30",
  DROPPED_AT_WAREHOUSE: "bg-amber-500/10 text-amber-300 border-amber-500/30",
  RECEIVED_AT_WAREHOUSE: "bg-purple-500/10 text-purple-400 border-purple-500/30",
  SORTING_IN_WAREHOUSE: "bg-indigo-500/10 text-indigo-300 border-indigo-500/30",
  ADDED_TO_OUTBOUND_BATCH: "bg-sky-500/10 text-sky-300 border-sky-500/30",
  OUTBOUND_BATCH_READY: "bg-teal-500/10 text-teal-300 border-teal-500/30",
  SHIPPED_OUT: "bg-orange-500/10 text-orange-400 border-orange-500/30",
  READY_FOR_LAST_MILE_PICKUP: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30",
  OUT_FOR_LAST_MILE: "bg-cyan-500/10 text-cyan-300 border-cyan-500/30",
  DELIVERED: "bg-green-500/10 text-green-400 border-green-500/30",
  ON_HOLD_WAREHOUSE_ISSUE: "bg-red-500/10 text-red-400 border-red-500/30",
  CANCELLED: "bg-red-500/10 text-red-400 border-red-500/30",
};

const BATCH_LABELS = {
  DRAFT: "Draft",
  OPEN_FOR_ADDING_PACKAGES: "Open · Adding",
  READY_FOR_DISPATCH: "Ready for Dispatch",
  SHIPPED_OUT_FROM_WAREHOUSE: "Shipped Out",
  READY_FOR_LAST_MILE_PICKUP: "Ready for Last-Mile",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
};

const BATCH_COLORS = {
  DRAFT: "bg-slate-700/40 text-slate-700 dark:text-slate-300 border-slate-300 dark:border-slate-600",
  OPEN_FOR_ADDING_PACKAGES: "bg-sky-500/10 text-sky-300 border-sky-500/30",
  READY_FOR_DISPATCH: "bg-teal-500/10 text-teal-300 border-teal-500/30",
  SHIPPED_OUT_FROM_WAREHOUSE: "bg-orange-500/10 text-orange-300 border-orange-500/30",
  READY_FOR_LAST_MILE_PICKUP: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30",
  COMPLETED: "bg-green-500/10 text-green-400 border-green-500/30",
  CANCELLED: "bg-red-500/10 text-red-400 border-red-500/30",
};

const USER_COLORS = {
  PENDING: "bg-yellow-500/10 text-yellow-400 border-yellow-500/30",
  APPROVED: "bg-green-500/10 text-green-400 border-green-500/30",
  REJECTED: "bg-red-500/10 text-red-400 border-red-500/30",
  SUSPENDED: "bg-red-500/10 text-red-400 border-red-500/30",
};

export const PACKAGE_STATUS_LABELS = PACKAGE_LABELS;
export const BATCH_STATUS_LABELS = BATCH_LABELS;

export function BatchStatusBadge({ status }) {
  const cls = BATCH_COLORS[status] || "bg-slate-200 dark:bg-slate-800 text-slate-700 dark:text-slate-300 border-slate-300 dark:border-slate-700";
  return (
    <span
      data-testid={`batch-status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wider border ${cls}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      {BATCH_LABELS[status] || status}
    </span>
  );
}

export function PackageStatusBadge({ status }) {
  const cls = PACKAGE_COLORS[status] || "bg-slate-200 dark:bg-slate-800 text-slate-700 dark:text-slate-300 border-slate-300 dark:border-slate-700";
  return (
    <span
      data-testid={`pkg-status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wider border ${cls}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      {PACKAGE_LABELS[status] || status}
    </span>
  );
}

export function UserStatusBadge({ status }) {
  const cls = USER_COLORS[status] || "bg-slate-200 dark:bg-slate-800 text-slate-700 dark:text-slate-300 border-slate-300 dark:border-slate-700";
  return (
    <span
      data-testid={`user-status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wider border ${cls}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      {status?.toLowerCase()}
    </span>
  );
}
